import React, { useCallback, useImperativeHandle, useRef, useState } from "react";
import { isEqual, isFunction } from "@util/utils";
import StoreTransferDialog from "./StoreTransferDialog";
import DefectReturnDialog from "./DefectReturnDialog";

const STORE_TRANSFER_DIALOG = "StoreTransferDialog";
const DEFECT_RETURN_DIALOG = "DefectReturnDialog";

/**
 * 出貨單管理 DialogBox 管理器
 * open 方法簽名：openXxxDialog(targetData, refreshFn)
 * targetData：外層提供的資料（各 dialog 從 sourceData 讀取）
 * refreshFn：供 dialog 情境使用（送出後呼叫）
 */
const ShipmentDialogBox = React.forwardRef((props, ref) => {
	const [openDialog, setOpenDialog] = useState("");
	const [sourceData, setSourceData] = useState(null);
	const refreshRef = useRef(null);

	const handleDialogClose = useCallback(() => {
		setOpenDialog("");
		setSourceData(null);
		refreshRef.current = null;
	}, []);

	const doRefresh = (...arg) => {
		const fn = refreshRef.current;
		if (!isFunction(fn)) return;
		setTimeout(() => fn(...arg), 5);
	};

	useImperativeHandle(
		ref,
		() => ({
			// 開啟店鋪調撥單彈窗
			openStoreTransferDialog: (targetData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetData);
				setOpenDialog(STORE_TRANSFER_DIALOG);
			},
			// 開啟瑕疵退貨單彈窗
			openDefectReturnDialog: (targetData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetData);
				setOpenDialog(DEFECT_RETURN_DIALOG);
			},
			// 關閉彈窗
			closeDialog: () => {
				handleDialogClose();
			},
		}),
		[handleDialogClose]
	);

	return (
		<>
			<StoreTransferDialog
				open={isEqual(openDialog, STORE_TRANSFER_DIALOG)}
				onClose={handleDialogClose}
				sourceData={sourceData}
				refresh={doRefresh}
			/>
			<DefectReturnDialog
				open={isEqual(openDialog, DEFECT_RETURN_DIALOG)}
				onClose={handleDialogClose}
				sourceData={sourceData}
                refresh={doRefresh}
			/>
		</>
	);
});

ShipmentDialogBox.displayName = "ShipmentDialogBox";

export default ShipmentDialogBox;
